import { combineReducers } from 'redux';

import domains from './domains';
import selected from './selected';

const filters = combineReducers({
  domains,
  selected,
});

export default filters;
